<script lang="ts">
  import PlatformHero from './components/PlatformHero.svelte'
  import Security from './components/Security.svelte'
  import DefiProtocols from './components/DefiProtocols.svelte'
  import FAQs from '../components/FAQs.svelte'
  import Footer from '../components/Footer.svelte'
</script>

<div class="fade-in space-y-16 md:space-y-32 sm-desktop:space-y-52 lg-desktop:space-y-64">
  <PlatformHero />
  <Security />
  <DefiProtocols />
  <FAQs />
  <Footer nextPage="Roadmap" pageLink="/roadmap" />
</div>
